import { FunctionComponent, useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import { useAuth } from '@sky/xerxes-client-react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

const SingleSignOn: FunctionComponent = () => {
  const { handleSignInRedirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const delayedSignIn = setTimeout(() => {
      handleSignInRedirect()
        .then(() => navigate('/', { replace: true }));
    }, 500);

    return () => {
      clearTimeout(delayedSignIn);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container>
      <Row>
        <Col>
          <h1>Signing you In</h1>
          <h3>Please Wait...</h3>
        </Col>
      </Row>
    </Container>
  );
};

export default SingleSignOn;
